<script setup lang="ts">
import merge from 'lodash-es/merge';

defineOptions({
    name: 'WidgetAnnouncementsSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const module = ref<string>('int_announcements');
const defaults = ref<any>({
    pageId: null,
    display: '10'
});

const form = computed<FormType<any>>(() =>
{
    return props.modelValue;
});

const displayOptions = computed((): Option[] =>
{
    return [
        { value: '3', text: $t('[[[3]]]') as string },
        { value: '5', text: $t('[[[5]]]') as string },
        { value: '10', text: $t('[[[10]]]') as string }
    ];
});

async function validate(): Promise<void>
{
    form.value.validate(schema => ({
        settings: schema.object({
            pageId: schema.string().nullable().required($t('[[[Wybranie strony jest wymagane]]]'))
        })
    }));
}

const triggetModel = (): void =>
{
    emit('update:modelValue', form.value);
};

watch(() => form.value.settings, (value: any) =>
{
    triggetModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});

defineExpose({
    validate
});
</script>

<template>
    <div>
        <IdeoFormGroup :label="$t('[[[Wybór strony]]]')" :invalid-feedback="form.$errors.first('settings.pageId')" :state="form.$errors.state('settings.pageId')" required>
            <EditoPageSelector v-model="form.settings.pageId" :module="module" :preview="false" label="" />
        </IdeoFormGroup>
        <IdeoFormGroup :label="$t('[[[Liczba wyświetlanych ogłoszeń]]]')" :invalid-feedback="form.$errors.first('settings.display')" :state="form.$errors.state('settings.display')">
            <IdeoFormSelect v-model="form.settings.display" :options="displayOptions" />
        </IdeoFormGroup>
    </div>
</template>
